module.exports = __webpack_public_path__ + "img/antes_despues_144.0b599a05.png";